import { extendTheme, ThemeConfig } from '@chakra-ui/react';

export const breakpointMap = {
  mobileBreakpoint: 801,
  mediumBreakpoint: 1024,
  largeBreakpoint: 1366,
  extraLargeBreakpoint: 1600,
};

// Based on gaming layer-mapping
// https://descomplica.slack.com/archives/C02BPTZ0U/p1519827202000577
export const zIndexMap = {
  background: -1,
  ground: 0,
  hill: 1,
  sky: 2,
  stars: 3,
  hud: 4,
};

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
};

export const neutralColor = {
  50: '#F2F2F3',
  100: '#E5E6E7',
  200: '#CACCCE',
  400: '#a3a3a3',
  600: '#636769',
  900: '#191A1A',
};

export const colors = {
  neutralColor,
  descomplica: {
    // New Green Pallete
    green: {
      primary: '#00e88F',
      light: '#4affb1',
      brightLight: '#9ae6b4',
      musk: '#68d391',
      200: '#e0fff2',
      dark: '#00c974',
      darker: '#25855a',
      secondary: '#239e5d',
      tertiary: '#48bb78',
    },
    blackboard: {
      dark: '#000000',
      primary: '#111111',
    },
    // New Gray Pallete
    gray: {
      'background-white': '#ffffff',
      'overlay-white-80': 'rgba(255, 255, 255, 0.8)',
      'secondary-gray-10': '#f5f5f5',
      'secondary-gray-30': '#dddddd',
      'secondary-gray-60': '#999999',
      'secondary-gray-80': '#666666',
      'secondary-gray-85': '#313335',
      'secondary-gray-90': '#333333',
      'black-90': '#111111',
      'black-100': '#000000',
      'overlay-gray-50': 'rgba(0, 0, 0, 0.5)',
      'overlay-gray-25': 'rgba(0, 0, 0, 0.25)',
      'overlay-gray-20': 'rgba(0, 0, 0, 0.2)',
      'overlay-gray-10': 'rgba(17, 17, 17, 0.1)',
      'overlay-gray-5': 'rgba(17, 17, 17, 0.05)',
      'overlay-blueish-gray-10': 'rgba(45, 55, 72, 0.1)',
      'overlay-blueish-gray-4': 'rgba(45, 55, 72, 0.04)',
      lightGray: '#dddddd',
      superLightGray: '#e2e8f0',
      ultraLightGray: '#edf2f7',
      mediumGray: '#a0aec0',
      mediumLightGray: '#cbd5e0',
      darkGray: '#2d3748',
    },
    // Secondary colors
    secondary: {
      'secondary-red-background': '#dB3d4d',
      'secondary-red-hover': '#ff4d5f',
      'secondary-red-click': '#d33c3c',
      'secondary-red-dark': '#df4944',
      'secondary-red-superdark': '#a72521',
      'secondary-red-super-light': '#feb2b2',
      'secondary-purple-light': '#c497ff',
      'secondary-blue-light': '#76c5ff',
    },
    // Chakra Color Scheme
    // generated for Chakra with https://palette.saas-ui.dev/
    50: '#e5fdf4',
    100: '#89f4cb',
    200: '#00e28b',
    300: '#00be75',
    400: '#00aa69',
    500: '#008f58',
    600: '#00794b',
    700: '#00613c',
    800: '#005233',
    900: '#003c25',
  },
  feedback: {
    success: '#21A453',
    error: '#A62826',
  },
};

export const spacing = {
  xxs: '4px',
  xs: '8px',
  sm: '16px',
  gutter: '24px',
  md: '32px',
  lg: '40px',
  xg: '48px',
  xxl: '64px',
};

const descomplicaTheme = extendTheme({
  config,
  fonts: {
    heading: 'AprovaSans',
    body: 'AprovaSans',
    text: 'AprovaSans',
  },
  colors,
});

export const borders = {
  mediumGrayWithShadow: {
    border: `1px solid ${colors.descomplica.gray.mediumGray}`,
    boxShadow: '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)',
    borderRadius: '8px',
  },
};

export default descomplicaTheme;
